<script lang="ts">
    import {Swiper, SwiperSlide} from "swiper/svelte";
    import "swiper/css";
    import "swiper/css/pagination";
    import "swiper/css/navigation";
    import "swiper/css/autoplay";
    import {Autoplay, Navigation, Pagination} from "swiper";

    import {Rose} from "../rose";
    import GalleryImage from "../shared/GalleryImage.svelte";

    export let roses: Rose[];
    const slidesNumber = {
        slidesPerView: 1,
        breakpoints: {
            600: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 3
            },
            1800: {
                slidesPerView: 4
            }
        }
    };
</script>

{#key roses}
    <div id="carousel-container">
        <div class="swiper-button-prev"></div>
        <Swiper
                {...slidesNumber}
                loop="{true}"
                modules={[Navigation, Pagination, Autoplay]}
                navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next"
            }}
                pagination={{
                clickable: true,
                el: "#swiper-bullets"
            }}
                autoplay={{
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                }}
        >
            {#each roses as rose(rose)}
                <SwiperSlide>
                    <GalleryImage rose="{rose}" block="{false}"/>
                </SwiperSlide>
            {/each}
        </Swiper>
        <div class="swiper-button-next"></div>
    </div>
    <div id="swiper-bullets"></div>
{/key}

<style>
    #carousel-container {
        display: flex;
        align-items: center;
        gap: 25px;
    }

    .swiper-button-next, .swiper-button-prev {
        position: relative;
        color: var(--main-color);
        
    }

    @media (max-width: 500px) {
        .swiper-button-next, .swiper-button-prev {
            display: none;
        }

    }

    #swiper-bullets {
        text-align: center;
        margin-bottom: 4px;
    }
</style>